export const ActionTypes = {
  SET_PRODUCTS: "SET_PRODUCTS",
  SELECTED_PRODUCTS: "SELECTED_PRODUCT",
  REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
  SELECT_CATEGORY: "SELECT_CATEGORY",
  REMOVE_SELECTED_CATEGORY: "REMOVE_SELECTED_CATEGORY"
};
